var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckmarkCircleOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4C7.313 4 3.5 7.813 3.5 12.5C3.5 17.187 7.313 21 12 21C16.687 21 20.5 17.187 20.5 12.5C20.5 7.813 16.687 4 12 4ZM12 22.5C6.486 22.5 2 18.014 2 12.5C2 6.986 6.486 2.5 12 2.5C17.514 2.5 22 6.986 22 12.5C22 18.014 17.514 22.5 12 22.5Z",
    fill: "#83D3AE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1237 15.7457C10.9327 15.7457 10.7397 15.6727 10.5938 15.5258L8.21975 13.1528C7.92675 12.8598 7.92675 12.3858 8.21975 12.0928C8.51275 11.7998 8.98675 11.7998 9.27975 12.0928L11.1237 13.9348L15.3397 9.71975C15.6328 9.42675 16.1067 9.42675 16.3997 9.71975C16.6927 10.0128 16.6927 10.4868 16.3997 10.7797L11.6537 15.5258C11.5078 15.6727 11.3157 15.7457 11.1237 15.7457Z",
    fill: "#83D3AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkCircleOutlined);
export default __webpack_public_path__ + "static/media/checkmark-circle-outlined.d303ca69c899a9f88ff164dc1ee7901f.svg";
export { ForwardRef as ReactComponent };